import React from 'react';
import { BhiDialog, DialogCloseButton, EmptyState } from 'src/UIKit';
import { DialogContent, DialogActions, Box, Button } from '@mui/material';
import { Close as CloseIcon, InsertDriveFile as FileIcon } from '@mui/icons-material';
import { CompanyDocument } from 'src/modules/companies/types';

interface DocumentPreviewModalProps {
  open: boolean;
  onClose: () => void;
  document: CompanyDocument | null;
}

export const DocumentPreviewModal = ({ open, onClose, document }: DocumentPreviewModalProps) => {
  const renderDocumentPreview = (document: CompanyDocument) => {
    const fileExtension = document.fileName.split('.').pop()?.toLowerCase();

    if (fileExtension === 'pdf' ||
      ['txt', 'csv', 'json', 'xml', 'html'].includes(fileExtension || '') ||
      ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'ico', 'webp'].includes(fileExtension || '')
    ) {
      return (
        <Box
          width="100%"
          height="70vh"
          overflow="hidden"
          border={1}
          borderColor="divider"
          borderRadius={1}
        >
          <iframe
            src={`${document.url}#toolbar=0&navpanes=0&scrollbar=0`}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            title={`Document Preview: ${document.fileName}`}
          />
        </Box>
      );
    }
    // For other document types, show download link
    return (
      <EmptyState
        height="70vh"
        p={4}
        icon={<FileIcon />}
        title={document.fileName}
        description="Preview not available for this file type."
        action={
          <Button
            variant="contained"
            href={document.url}
            download={document.fileName}
            target="_blank"
          >
            Download File
          </Button>
        }
      />
    );
  };

  return (
    <BhiDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      paperSx={{ overflow: 'hidden' }}
      title={document?.fileName ?? 'Document Preview'}
      showCloseButton={false}
    >
      <DialogCloseButton onClick={onClose}>
        <CloseIcon />
      </DialogCloseButton>
      <DialogContent sx={{ overflow: 'hidden', p: 0 }}>
        {document && renderDocumentPreview(document)}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </BhiDialog>
  );
};

export default DocumentPreviewModal;
